export default "__VITE_ASSET__BZvlyxkw__"